import { Language } from "@/lib/translations";
import { Img } from "./commonType";

export const sortTree = (treeArr:any)=>{
    treeArr.sort((a:any, b:any) => a.seq - b.seq);
    treeArr.forEach((item:any)=>{
        if(item.children.length>0){
            sortTree(item.children);
        }
    })
}

export const createTree = (menuData: any[],id:any,name:any)=>{
    // Step 1: Create a map to store each item by id
    const menuMap:any = {};
    menuData.forEach(item => {
        menuMap[item[id]] = { 
            ...item, 
            value: item[id], 
            label: item[name], 
            children: []
        }
    });
    
    // Step 2: Build the tree structure
    const tree: { [key: string]: any } = {};
    menuData.forEach((item:any) => {
        // Nested item, find its parent and add it to the parent's children array
        const parent = menuMap[item.parent_id];
        if (parent && item.parent_id!==item[id]) {
            parent.children.push(menuMap[item[id]]);
        }else{
            menuMap[item[id]].parent_id = item[id];
            tree[item[name]] = menuMap[item[id]];
        }
    });
    
    const treeArr = Object.keys(tree).map((key:string)=>{
        return tree[key];
    })
    sortTree(treeArr);
    return treeArr;
}

export const supportedLang = ['zh-HK', 'zh-CN', 'en-US'];

export const getStoredLang = ()=>{
  let lang = localStorage.getItem('langCode');

  if (!lang || !supportedLang.includes(lang)) {
    lang = 'zh-HK';
    localStorage.setItem('langCode', 'zh-HK');
  }

  return lang as Language;
}

type Result = {
  cat_id: string
  cat_code: string
  path: string
  label: string
  type: string
  navTarget: string
  url: string
} | null;

export const findMenuWithPath = (
  tree: any[],
  targetCode: string,
  targetCatId: string,
  targetMenuId: string,
  currentPath: string = ""
): Result => {
  for (const node of tree) {
    const tempCurrentPath = currentPath === "/" ? "" : currentPath;
    const subPath = `/${node.cat_code}`;

    let newPath = '';
    if(tempCurrentPath === subPath){
        newPath = subPath;
    }else{
      newPath = `${tempCurrentPath}${subPath}`;
    }

    let isMatch = false;
    if(targetCode && node.cat_code === targetCode){
      isMatch = true;
    }else if(targetCatId && node.cat_id == targetCatId){
      isMatch = true;
    }else if(targetMenuId && node.id == targetMenuId){
      isMatch = true;
    }

    if (isMatch) {
      return {
        cat_id: node.cat_id,
        cat_code: node.cat_code,
        path: newPath,
        label: node.label,
        type: node.type,
        navTarget: node.target, // map target -> navTarget
        url: node.url,
      };
    }

    if (node.children && node.children.length > 0) {
      const found = findMenuWithPath(
        node.children,
        targetCode,
        targetCatId,
        targetMenuId,
        newPath
      );
      if (found) return found;
    }
  }

  return null;
}

export const getContentFromSearchParams = (searchParams: any, content: string)=>{
  const params = content === 'cat_id' ? 'cat_id'
                  : content === 'section' ? 'section'
                  : content;
  if(!params){
    return null;
  }
  return searchParams.get(params);
}

export const convertRawHtmlStr = (html: any)=>{
  if(html == null){
    return '';
  }

  if (html.trim() === '<p></p>' || html.trim() === '<p><br></p>') {
    return '';
  }

  return html.replace(/<p><\/p>/g, '<br/>').replace(/<\/p><p>/g, '<br/>').replace(/&nbsp;/g, ' ');
}

export const checkImageIsHTTP = (imageStr: string)=>{
  if(imageStr.startsWith('http://') || imageStr.startsWith('https://')){
    return true;
  }
  return false;
}

export const getImageSrc = (thumbnails: any): Img=>{
  const mediaDomain: string = process.env.NEXT_PUBLIC_MEDIA_DOMAIN!;

  function getSrc(path?: string){
    if(path){
      return checkImageIsHTTP(path) ? path : mediaDomain + path;
    }
    return '';
  }

  return {
    desktopSrc: getSrc(thumbnails?.[0]?.med_path),
    mobileSrc: getSrc(thumbnails?.[1]?.med_path),
  };

  // if(!src) return '';

  // if(checkImageIsHTTP(src)){
  //   return src;
  // }

  // const signatures = {
  //   jpg: ["/9j/"],
  //   png: ["iVBORw0KGgo"],
  //   svg: ["PHN2Zy"],
  //   mp4: ["AAAAIGZ0eXA", "AAAAGGZ0eXA"]
  // }

  // let fileType = '';

  // for (const [type, sigList] of Object.entries(signatures)) {
  //   if (sigList.some(sig => src.startsWith(sig))) {
  //     fileType = type;
  //     break;
  //   }
  // }

  // if (!fileType && src.includes("Z0dXA")) {
  //   fileType = 'mp4';
  // }

  // switch (fileType) {
  //   case 'svg':
  //     return `data:image/svg+xml;base64,${src}`;
  //   case 'png':
  //     return `data:image/png;base64,${src}`;
  //   case 'jpg':
  //     return `data:image/jpeg;base64,${src}`;
  //   case 'mp4':
  //     return `data:video/mp4;base64,${src}`;
  //   default:
  //     return `data:image/jpeg;base64,${src}`; // fallback
  // }

}

export const formatDateByLang = (dateStr: string | null | undefined, lang: string) => {
    if (!dateStr) return '';

    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '';

    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 0-based
    const day = date.getDate();

    if (lang === 'zh-HK' || lang === 'zh-CN') {
        return `${year}年${month}月${day}日`;
    }

    if (lang === 'en-US') {
        // e.g. March 1, 2025
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    }

    // fallback
    return dateStr;
};

export const getDocumentTitle = (documentTitle: string)=>{
  return 'PCHK - ' + documentTitle;
}